import React from "react";
import Layout from "components/Layout";
import BatchControlForm from "./components/BatchControlForm";

function BatchControl() {
  return (
    <Layout title="염수 일괄분사">
      <BatchControlForm />
    </Layout>
  );
}

export default BatchControl;